module.exports = __webpack_public_path__ + "static/media/promocion.bdb0ae5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/promocion.svg
// module id = 142
// module chunks = 0